<div class="sync-history-detail-container view">
    @if (isLoading) {
        <div class="loading">
            <mat-spinner color="accent" diameter="40"></mat-spinner>
            <p>Loading sync details...</p>
        </div>
    }

    @if (error) {
        <div class="error-message">
            <mat-icon>error</mat-icon>
            <p>{{ error }}</p>
        </div>
    }

    @if (!isLoading && syncHistory) {
        <mat-card class="cardPlain">
    <div class="custom-card-header">
      <div class="section-header">
        <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
        <h1 class="m-0 f-w-500">{{ syncHistory.companyName || 'All companies' }}</h1>
        <p class="m-0 help-text">
          Started: {{ syncHistory.startedAt | date: 'medium' }}
            @if (syncHistory.completedAt) {
            • Completed: {{ syncHistory.completedAt | date: 'medium' }}
            }
        </p>
      </div>

      <span class="spacer"></span>

      <span class="status-pill" [ngClass]="getStatusClass(syncHistory.status)">
        <mat-icon>{{ statusIcon(syncHistory.status) }}</mat-icon>
        {{ statusLabel(syncHistory.status) }}
      </span>
    </div>

    <mat-card-content class="d-flex flex-col gap-24">
      <section class="tab-section d-flex flex-col gap-16">
        <div class="section-header">
          <h4 class="m-0 f-s-16 f-w-600">Details</h4>
        </div>

        <div class="details-grid">
          <div class="detail-item">
            <div class="detail-label">Sync type</div>
            <div class="detail-value">{{ formatSyncType(syncHistory.syncType) }}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Synced by</div>
            <div class="detail-value">{{ syncHistory.syncedBy || 'System' }}</div>
          </div>

            @if (syncHistory.orgNumber) {
                <div class="detail-item">
                    <div class="detail-label">Organization number</div>
                    <div class="detail-value">{{ syncHistory.orgNumber }}</div>
                </div>
            }

          <div class="detail-item">
            <div class="detail-label">Started</div>
            <div class="detail-value">{{ syncHistory.startedAt | date: 'medium' }}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Completed</div>
              <div class="detail-value">
              {{ syncHistory.completedAt ? (syncHistory.completedAt | date: 'medium') : 'N/A' }}
              </div>
          </div>

            @if (syncHistory.affectedRecords !== undefined || syncHistory.totalRecords !== undefined) {
                <div class="detail-item">
                    <div class="detail-label">Records</div>
                    <div class="detail-value">
                        {{ syncHistory.affectedRecords ?? 0 }} affected
                        @if (syncHistory.totalRecords !== undefined) {
                            of {{ syncHistory.totalRecords }}
                        }
                    </div>
                </div>
            }

            @if (syncHistory.message) {
                <div class="detail-item full-width">
                    <div class="detail-label">Message</div>
                    <div class="detail-value">{{ syncHistory.message }}</div>
                </div>
            }
        </div>
      </section>

      <section class="tab-section d-flex flex-col gap-16">
        <div class="section-header">
          <h4 class="m-0 f-s-16 f-w-600">Changes</h4>
          <p class="m-0 f-s-14 text-gray-100">Detailed field changes recorded for this sync.</p>
        </div>

          @if (syncHistory.changes?.length) {
              <div class="table-responsive">
                  <table
                          [class.is-empty]="!(syncHistory.changes?.length ?? 0)"
                          [dataSource]="syncHistory.changes ?? []"
                          class="webinars-table webinars-table--inner-padding"
                          mat-table
                  >
                      <ng-container matColumnDef="field">
                          <th *matHeaderCellDef mat-header-cell>Field</th>
                          <td *matCellDef="let change" mat-cell>{{ change.field }}</td>
                      </ng-container>

                      <ng-container matColumnDef="oldValue">
                          <th *matHeaderCellDef mat-header-cell>Old value</th>
                          <td *matCellDef="let change" mat-cell>{{ change.oldValue ?? 'N/A' }}</td>
                      </ng-container>

                      <ng-container matColumnDef="newValue">
                          <th *matHeaderCellDef mat-header-cell>New value</th>
                          <td *matCellDef="let change" mat-cell>{{ change.newValue }}</td>
                      </ng-container>

                      <tr *matHeaderRowDef="changeColumns" mat-header-row></tr>
                      <tr *matRowDef="let row; columns: changeColumns" mat-row></tr>
                  </table>
              </div>
          } @else {
          <div class="empty-state" role="region" aria-live="polite">
            <h3 class="title">No changes recorded</h3>
            <p class="description">This sync event did not include detailed field changes.</p>
          </div>
          }
      </section>
    </mat-card-content>
        </mat-card>
    }

    @if (!isLoading && !syncHistory && !error) {
        <div aria-live="polite" class="empty-state" role="region">
            <h3 class="title">Not found</h3>
            <p class="description">This sync history event could not be loaded.</p>
        </div>
    }
</div>
